// extracted by mini-css-extract-plugin
export default {"total":"Cart_total__6wXyP","discount":"Cart_discount__EdIj5","actions":"Cart_actions__8ncVn","cartItems":"Cart_cartItems__Mf5VQ"};